import axios from '../axiosConfig.jsx'

export default async function addLocation(payload) {
    return await axios.post(`/partners/locations/detail`, payload).then(res => res.data)
}